<template>
    <div class="stars d-flex align-items-center" @mouseout="unselect"
         :style="[starFontSize, starMarginAuto, starWidth]">
        <div class="star-wrapper d-flex align-items-center" v-for="star in range" @click="check($event, star)"
             @mouseover="select(star)" :key="star" :class="{'cursor-pointer': !disabled}"><i class="fa fa-fw"
                                                                                             :class="{'checked' : isChecked(star), 'filled' : isFilled(star), [icon]: true, 'cursor-pointer': !disabled}"
                                                                                             :style="{color: isChecked(star) || isFilled(star) ? color : uncheckedColor}"></i><span
                class="number" v-if="showNumbers"
                :class="{'checked' : isChecked(star), 'filled' : isFilled(star)}">{{ star }}</span></div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            stars: {default: 5},
            value: {default: 0},
            icon: {default: 'fa-star'},
            showNumbers: {default: false},
            color: {default: '#ffb600'},
            uncheckedColor: {default: '#eee'},
            disabled: {default: false},
            fontSize: {default: '43px'},
            margin: {default: 'auto'},
            width: {default: '100%'}
        },

        data() {
            return {
                filled: null,
                checked: null,
            };
        },

        created() {
            this.checked = this.value;
        },

        computed: {
            range() {
                return this.showNumbers ? _.range(0, this.stars + 1) : this.stars;
            },

            starFontSize() {
                return `font-size: ${this.fontSize}`;
            },

            starMarginAuto() {
                return `margin: ${this.margin}`;
            },

            starWidth() {
                return `width: ${this.width}`;
            }
        },

        methods: {
            isChecked(star) {
                if (this.checked == null) return false;
                return this.checked >= star;
            },
            isFilled(star) {
                if (this.filled == null) return false;
                return this.filled >= star;
            },
            select(star) {
                if (this.disabled) return;
                this.filled = star;
            },
            unselect() {
                if (this.disabled) return;
                this.filled = null;
            },

            check(e, star) {
                if (this.disabled) return;
                this.checked = this.checked === star ? null : star;
                this.$emit('input', this.checked);
            },
        }
    };
</script>

<style lang="sass" scoped>
    @import '../../../sass/media'

    .stars
        text-align: center
        position: relative

        .star-wrapper
            position: relative

            i.fa
                position: relative

                &.checked
                    opacity: 0.9

                &.filled
                    opacity: 1

            .number
                color: black
                position: absolute
                z-index: 1
                left: 0
                right: 0
                text-align: center
                font-size: 0.8rem

                @include respond-below(sm)
                    font-size: 1.2rem

                &.checked, &.filled
                    color: white

    @media screen and (max-width: 767px)
        .stars
            i.fa
                font-size: .8em
</style>
